// Unified user option builder used across the platform for user pickers, filters and search
// (buyers, managers and tenant admins). Individual screens may filter the source list locally
// if they need a specific subset of roles.
// Label format: `#ID — Name · Email`. Search matches by ID (tenant_seq), name and email.
export function userOption(u) {
  const seq = u.tenant_seq;
  const idPart = seq != null ? `#${seq}` : "";
  const name = u.name || u.email || "—";
  const head = idPart ? `${idPart} — ${name}` : name;
  const label = u.email && u.email !== name ? `${head} · ${u.email}` : head;
  const search = `${idPart} ${seq != null ? seq : ""} ${name} ${u.username || ""} ${u.email || ""}`.trim();
  return { value: u.id, label, search };
}

export function userOptions(list) {
  // Platform-wide user pickers: newest (highest #ID) first.
  return [...(list || [])].sort((a, b) => (b.tenant_seq ?? -1) - (a.tenant_seq ?? -1)).map(userOption);
}
